export class ToggleSection {
  id: string;
  name: string;
  selected: boolean;

  constructor(id: string, name: string, selected: boolean) {
    this.id = id;
    this.name = name;
    this.selected = selected;
  }
}

export class ToggleSectionsForForm {
  formId: string;
  formName: string;
  toggleSections: ToggleSection[];

  constructor(
    formId: string,
    formName: string,
    toggleSections: ToggleSection[],
  ) {
    this.formId = formId;
    this.formName = formName;
    this.toggleSections = toggleSections;
  }
}
